<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="abb"><a id="page_xx"></a><a href="#/xhtml/contents#abb">Abbreviations</a></p>
<table cellpadding="0" cellspacing="0" class="abbre">
<tbody><tr>
<td>AB</td>
<td>Anchor Bible</td>
</tr>
<tr>
<td><i>ExpT</i></td>
<td><i>Expository Times</i></td>
</tr>
<tr>
<td>GE</td>
<td>The Brill Dictionary of Ancient Greek</td>
</tr>
<tr>
<td><i>JSNT</i></td>
<td><i>Journal for the Study of the New Testament</i></td>
</tr>
<tr>
<td>JSNTSup</td>
<td>Journal for the Study of the New Testament Supplement Series</td>
</tr>
<tr>
<td>NIGTC</td>
<td>New International Greek Testament Commentary</td>
</tr>
<tr>
<td><i>NTS</i></td>
<td><i>New Testament Studies</i></td>
</tr>
<tr>
<td><i>SJT</i></td>
<td><i>Scottish Journal of Theology</i></td>
</tr>
<tr>
<td>WUNT</td>
<td>Wissenschaftliche Untersuchungen zum Neuen Testament</td>
</tr>
<tr>
<td><i>ZTK</i></td>
<td><i>Zeitschrift für Theologie und Kirche</i></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?75b35cf2